$(document).ready(function () {
    var transactionStatus = $("#chip-card-transaction-status");
    if (typeof transactionStatus !== 'undefined') {
        transactionStatus.trigger("focus");
    }
});